export default "__VITE_ASSET__BeCbD$W9__"